import { linkedPackage } from 'lincd/utils/Package';

export const {
  linkedComponent,
  linkedSetComponent,
  linkedShape,
  linkedUtil,
  linkedOntology,
  registerPackageExport,
  registerPackageModule,
  packageExports,
  packageName,
} = linkedPackage('peacegame');
